/**
 * Inspired by the Material Design Input:
 * https://github.com/angular/components/blob/master/src/material/input/input.ts
 */
import { Directive, forwardRef, HostBinding, HostListener, inject, Input } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MuiFormFieldSubmit } from '../form-field/submit/mui-form-field-submit.component';
import { MuiInputBaseDirective } from './mui-input-base.directive';


let nextUniqueId = 0;

@Directive({
  selector: `
  input[muiInput],
  select[muiInput],
  textarea[muiInput]`,
  exportAs: 'muiInput',
  providers: [{ provide: MuiInputBaseDirective, useExisting: forwardRef(() => MuiInputDirective) }]
})
export class MuiInputDirective extends MuiInputBaseDirective<string> {
  @Input() hasPasswordToggle = false;

  @Input()
  @HostBinding('attr.type')
  type: string | null = 'text';

  muiSubmit?: MuiFormFieldSubmit;

  parentForm: FormGroupDirective | null = inject(FormGroupDirective, { optional: true, host: true, skipSelf: true });
  protected _uid = `mui-input-${nextUniqueId++}`;

  @HostListener('keydown.enter')
  onEnterPressed(): void {
    if (!this.parentForm && this.muiSubmit) {
      this.muiSubmit.submit();
    }
  }
}
